import React, { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";

const Categorias = () => {
  const { dbCategories = [], loadCategories } = useContext(CartContext);
  const [show, setShow] = useState(false);

  const [nombre, setNombre] = useState("");
  const [foto, setFoto] = useState(null);
  const [preview, setPreview] = useState(null);
  const [editId, setEditId] = useState(null);

  const handleClose = () => {
    setShow(false);
    resetForm();
  };

  const handleShow = () => setShow(true);

  const resetForm = () => {
    setNombre("");
    setFoto(null);
    setPreview(null);
    setEditId(null);
  };

  const prepararEdicion = (cat) => {
    setEditId(cat.id);
    setNombre(cat.nombre);
    setPreview(cat.imagen);
    setFoto(null);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFoto(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!nombre.trim()) return Swal.fire("Error", "Falta el nombre", "error");
    if (!editId && !foto)
      return Swal.fire("Error", "Debes seleccionar una imagen", "error");

    try {
      const data = new FormData();
      data.append("action", editId ? "update" : "add");
      if (editId) data.append("id", editId);
      data.append("nombre", nombre.trim());
      if (foto) data.append("imagen", foto);

      const resp = await fetch(
        "https://espacioanalogico.com.ar/api/manage_categories.php",
        {
          method: "POST",
          body: data,
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        resetForm();
        if (loadCategories) await loadCategories();
        Swal.fire({
          title: editId ? "Actualizada" : "Creada",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire("Error", res.message || "Error", "error");
      }
    } catch (e) {
      Swal.fire("Error", "Error de conexión", "error");
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "¿Eliminar?",
      text: "Se borrará definitivamente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const resp = await fetch(
            "https://espacioanalogico.com.ar/api/manage_categories.php",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ action: "delete", id }),
              credentials: "include",
            },
          );
          const res = await resp.json();
          if (res.success) {
            if (loadCategories) await loadCategories();
            Swal.fire("Eliminada", "", "success");
            if (editId === id) resetForm();
          }
        } catch (error) {
          Swal.fire("Error", "No se pudo borrar", "error");
        }
      }
    });
  };

  return (
    <>
      <div className="boton" onClick={handleShow} style={{ cursor: "pointer" }}>
        Categorias
      </div>

      <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
        <Modal.Header closeButton className="bg-secondary text-white">
          <Modal.Title>
            {editId ? "Editando Categoría" : "Gestión de Categorías"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          <div className="row">
            <div className="col-md-6 border-end">
              <h6 className="fw-bold mb-3 text-uppercase small text-muted">
                Categorías (Click para editar)
              </h6>
              <div
                style={{ maxHeight: "450px", overflowY: "auto" }}
                className="pe-2"
              >
                {dbCategories.map((cat) => (
                  <div
                    className={`card mb-2 shadow-sm border-0 ${editId === cat.id ? "border border-primary" : ""}`}
                    key={cat.id}
                    style={{ cursor: "pointer" }}
                    onClick={() => prepararEdicion(cat)}
                  >
                    <div className="card-body d-flex align-items-center p-2">
                      {cat.imagen ? (
                        <img
                          src={cat.imagen}
                          alt=""
                          className="rounded"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div
                          className="rounded bg-secondary text-white d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            fontSize: "9px",
                          }}
                        >
                          SIN FOTO
                        </div>
                      )}
                      <span className="ms-3 fw-bold flex-grow-1 text-truncate">
                        {cat.nombre}
                      </span>
                      <button
                        className="btn btn-outline-danger btn-sm border-0"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(cat.id);
                        }}
                      >
                        <i className="bi bi-trash3"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-md-6">
              <h6 className="fw-bold mb-3 text-uppercase small text-muted">
                {editId ? "Modificar" : "Nueva"}
              </h6>
              <div className="card shadow-sm border-0 p-3">
                <input
                  type="text"
                  className="form-control mb-3"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder="Nombre"
                />
                <input
                  type="file"
                  className="form-control form-control-sm mb-3"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <div
                  className="rounded mb-3 border bg-white d-flex align-items-center justify-content-center"
                  style={{ height: "180px", overflow: "hidden" }}
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <small className="text-muted">Sin imagen</small>
                  )}
                </div>
                <div className="d-flex gap-2">
                  <button
                    className={`btn w-100 fw-bold ${editId ? "btn-primary" : "btn-success"}`}
                    onClick={handleSubmit}
                  >
                    {editId ? "ACTUALIZAR" : "GUARDAR"}
                  </button>
                  {editId && (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={resetForm}
                    >
                      X
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Categorias;
